import React from "react";
import {Link} from "react-router-dom";
import Social from "../../data/social";

const SideBar = ({isOpen, setIsOpen, general}) => {
    const contact = general?.contact;

    if (!general) return null;

    return (
        <>
            <div
                className={`header__area-menubar-right-sidebar-popup ${
                    isOpen ? "active" : ""
                }`}
            >
                {/* CLOSE */}
                <div
                    className="sidebar-close-btn"
                    onClick={() => setIsOpen(false)}
                >
                    <i className="fal fa-times"></i>
                </div>

                {/* LOGO */}
                <div className="header__area-menubar-right-sidebar-popup-logo">
                    <Link to="/" onClick={() => setIsOpen(false)}>
                        <img
                            src={general.logo2}
                            alt={general.companyName}
                        />
                    </Link>
                </div>

                {/* MOTTO */}
                {(general.mottoEn || general.mottoId) && (
                    <div className="sidebar-motto-group">

                        {general.mottoEn && (
                            <div
                                className="sidebar-motto sidebar-motto--en"
                                dangerouslySetInnerHTML={{
                                    __html: general.mottoEn,
                                }}
                            />
                        )}

                        {general.mottoId && (
                            <div
                                className="sidebar-motto sidebar-motto--id"
                                dangerouslySetInnerHTML={{
                                    __html: general.mottoId,
                                }}
                            />
                        )}

                    </div>
                )}


                {/* CONTACT */}
                <div className="header__area-menubar-right-sidebar-popup-contact">
                    <h4 className="mb-30">
                        <i className="flaticon-contact-book" style={{marginRight: 8}}/>
                        Visit Our Office
                    </h4>
                    {/* OFFICE (LOOP) */}
                    {Array.isArray(contact?.office) &&
                        contact.office.map((office, index) => (
                            <div
                                key={index}
                                className="header__area-menubar-right-sidebar-popup-contact-item"
                            >
                                <div className="footer__two-widget-location-item-icon">
                                    <i className="flaticon-location"/>
                                </div>
                                <div className="header__area-menubar-right-sidebar-popup-contact-item-content">
                                    <span>{office.label || "Office"}</span>
                                    <h6>
                                        <a
                                            href={office.gmaps}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {office.address}
                                        </a>
                                    </h6>
                                </div>
                            </div>
                        ))}
                </div>


                {/* SOCIAL */}
                <div className="header__area-menubar-right-sidebar-popup-social">
                    <Social
                        email={contact?.email}
                        phone={contact?.phone}
                        wa={contact?.wa}
                    />
                </div>
            </div>

            {/* OVERLAY */}
            <div
                className={`sidebar-overlay ${isOpen ? "show" : ""}`}
                onClick={() => setIsOpen(false)}
            />
        </>
    );
};

/* helpers */
const formatPhone = (phone) => {
    if (!phone) return "";
    return phone.startsWith("62") ? "0" + phone.slice(2) : phone;
};

const normalizePhone = (phone) => {
    if (!phone) return "";
    return phone.startsWith("0") ? "62" + phone.slice(1) : phone;
};

export default SideBar;
